var _ellipse, _path, _path2, _ellipse2, _ellipse3, _rect, _path3, _path4, _path5, _ellipse4, _rect2, _path6, _path7, _path8, _path9, _ellipse5, _ellipse6, _path10, _path11, _ellipse7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 773,
    viewBox: "0 0 1440 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 781.397,
    cy: 623.911,
    rx: 19.1391,
    ry: 15.0169,
    transform: "rotate(143.95 781.397 623.911)",
    fill: "#F3B1A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1140.47 184.045C1134.67 185.289 1128.68 180.301 1127.09 172.903C1125.5 165.505 1128.92 158.499 1134.73 157.255C1140.53 156.01 1146.52 160.998 1148.11 168.396C1149.69 175.794 1146.28 182.8 1140.47 184.045Z",
    fill: "#F3876F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M453.964 236.797C450.118 233.781 452.24 225.441 458.704 218.168C465.169 210.896 473.527 207.445 477.373 210.46C481.219 213.475 479.097 221.816 472.632 229.088C466.168 236.361 457.81 239.812 453.964 236.797Z",
    fill: "#F3B1A2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.4453,
    ry: 12.7806,
    transform: "matrix(-0.664334 0.747436 -0.786967 -0.616995 1236.33 660.107)",
    fill: "#91D0C5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1348.19,
    cy: 285.649,
    rx: 26.3783,
    ry: 13.1017,
    transform: "rotate(-145.855 1348.19 285.649)",
    fill: "#C0D7D4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1359.45,
    y: 52,
    width: 34.8751,
    height: 68.6605,
    rx: 15,
    transform: "rotate(41.4517 1359.45 52)",
    fill: "#FCC34D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M921.649 278.303C927.298 280.128 929.993 287.443 927.667 294.643C925.342 301.843 918.878 306.201 913.229 304.376C907.579 302.552 904.885 295.236 907.21 288.036C909.535 280.837 916 276.479 921.649 278.303Z",
    fill: "#F3876F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.649 66.3034C331.298 68.1278 333.993 75.4434 331.667 82.6432C329.342 89.843 322.878 94.2006 317.229 92.3762C311.579 90.5518 308.885 83.2362 311.21 76.0364C313.535 68.8366 320 64.479 325.649 66.3034Z",
    fill: "#F3876F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.42 482.032C1025.06 488.581 1016.38 497.48 1003.04 501.909C989.707 506.337 976.76 504.618 974.127 498.069C971.494 491.52 980.171 482.621 993.508 478.193C1006.85 473.764 1019.79 475.483 1022.42 482.032Z",
    fill: "#C0D7D4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.294,
    cy: 271.452,
    rx: 26.3783,
    ry: 13.1017,
    transform: "rotate(64.1451 106.294 271.452)",
    fill: "#C0D7D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 659.094,
    y: 417.157,
    width: 18.6182,
    height: 36.6545,
    rx: 9.30908,
    transform: "rotate(-108.548 659.094 417.157)",
    fill: "#FCC34D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.67 537.529C1376.34 531.371 1389.67 539.069 1389.67 551.385L1389.67 588.456C1389.67 600.772 1376.34 608.471 1365.67 602.312L1333.57 583.777C1322.9 577.619 1322.9 562.223 1333.57 556.064L1365.67 537.529Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 399.061C1249.96 395.914 1250.98 392.768 1253.97 389.662C1255.97 387.599 1258.21 385.818 1260.64 384.357C1264.38 382.185 1269.97 383.317 1273.67 385.583C1275.6 386.754 1277.32 388.324 1278.71 390.198C1280.1 392.071 1281.15 394.211 1281.78 396.488C1282.81 399.822 1282.38 403.712 1280.51 408.158C1278.77 412.282 1274.44 418.489 1269.37 416.122C1265.67 414.405 1269.04 410.315 1270.39 408.352C1272.51 405.316 1274.22 401.933 1272.99 397.937C1271.32 392.505 1268.54 390.384 1264.64 391.573C1263.29 391.993 1262.1 392.814 1261.19 393.949C1260.85 394.366 1260.66 394.791 1261.14 395.272C1261.67 395.666 1262.25 395.987 1262.85 396.227C1263.39 396.507 1263.93 396.783 1264.49 397.032C1265.41 397.491 1266.3 398.016 1267.17 398.604C1267.91 399.107 1268.95 399.732 1269.03 400.807C1269.11 401.882 1268.34 402.237 1267.8 402.694C1267.06 403.38 1266.29 404.021 1265.48 404.613C1264.87 405.017 1264.21 405.333 1263.53 405.555C1261.06 406.261 1258.4 405.97 1256.02 404.735C1254.85 404.262 1253.77 403.51 1252.88 402.535C1251.99 401.561 1251.31 400.39 1250.88 399.113",
    fill: "#F05E52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.198 400.994C391.086 404.616 392.183 409.842 390.509 416.59C389.361 421.092 387.659 425.387 385.439 429.385C381.962 435.43 373.223 438.349 366.221 438.158C362.579 438.073 358.919 437.256 355.462 435.756C352.005 434.256 348.822 432.103 346.104 429.428C341.983 425.59 339.446 419.806 338.49 412.076C337.597 404.913 338.661 392.742 347.665 391.97C354.22 391.395 352.798 399.83 352.483 403.665C351.967 409.615 352.295 415.726 357.233 420.326C363.945 426.579 369.545 427.307 374.031 422.511C375.582 420.838 376.595 418.725 376.958 416.404C377.09 415.551 377.013 414.804 375.954 414.518C374.891 414.395 373.83 414.408 372.798 414.556C371.821 414.597 370.831 414.651 369.859 414.746C368.2 414.848 366.524 414.834 364.844 414.704C363.392 414.603 361.442 414.563 360.462 413.124C359.482 411.686 360.272 410.571 360.671 409.491C361.15 407.936 361.717 406.418 362.369 404.941C362.893 403.887 363.557 402.916 364.343 402.051C367.219 399.081 371.178 397.345 375.502 397.156C377.525 396.873 379.633 397.062 381.663 397.709C383.693 398.355 385.593 399.442 387.216 400.886",
    fill: "#F3876F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1709 57.2903C82.9165 51.4578 88.7823 46.5232 94.7294 48.4079L108.947 52.9137C114.894 54.7984 116.462 62.089 111.769 66.0367L100.551 75.4742C95.8581 79.4219 88.4243 77.066 87.1698 71.2335L84.1709 57.2903Z",
    fill: "#4CB7BF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.4453,
    ry: 12.7806,
    transform: "matrix(-0.889904 -0.456148 0.400422 -0.916331 111.32 684.474)",
    fill: "#F3B1A2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.4453,
    ry: 12.7806,
    transform: "matrix(-0.889904 -0.456148 0.400422 -0.916331 640.32 122.473)",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M371.199 668.005C376.532 665.331 382.778 669.776 382.441 676.005L381.637 690.898C381.3 697.127 374.634 700.47 369.638 696.914L357.693 688.415C352.697 684.859 353.117 677.072 358.45 674.398L371.199 668.005Z",
    fill: "#F3876F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M900.199 106.005C905.532 103.331 911.778 107.775 911.441 114.005L910.637 128.897C910.3 135.127 903.634 138.469 898.638 134.914L886.693 126.414C881.697 122.859 882.117 115.072 887.45 112.398L900.199 106.005Z",
    fill: "#F3876F"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 18.7443,
    ry: 14.4265,
    transform: "matrix(-0.752988 -0.658034 0.611964 -0.790886 105.943 497.744)",
    fill: "#FCC34D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.41d63207c9ec4eba0fc1496bf0e30ed3.svg";
export { ForwardRef as ReactComponent };